import React from 'react';
import { Navigate } from 'react-router-dom';
import { auth, db } from '../../services/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const [user, setUser] = React.useState(null);
  const [role, setRole] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userDoc = await getDoc(doc(db, "admins", currentUser.uid));
        if (userDoc.exists()) {
          setRole(userDoc.data().role);
        }
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  if (loading) return <div className='text-white'>Loading...</div>;

  if (!user) return <Navigate to="/sign-in" />;

  if (adminOnly && role !== "admin") {
    return <Navigate to="/not-authorized" />;
  }

  return children;
};

export default ProtectedRoute;
